@import url('https://fonts.googleapis.com/css2?family=Fira+Code:wght@300..700&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');

body {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  margin: 0;
  padding: 0;

  font-family: "Inter";
}

.app {
  color: white;
  background-color: black;

  display: flex;
  flex-direction: column;

  height: 100%;

  overflow: auto;
}

.cardContainer {
  display: flex;
}

.card {
  box-sizing: border-box;

  background-color: rgba(93, 96, 102, 0);
  background-image: url('./assets/grid_bg.png');
  backdrop-filter: blur(4px);

  border-top: 2px dotted rgba(255, 255, 255, 0.247);
  border-bottom: 2px dotted rgba(255, 255, 255, 0.247);
  

  position: relative;
  display: flex;
  flex-direction: column;

  margin: auto;

  padding: 2em;

  border-radius: 0px;
  max-width: 710px;
}


.title {
  font-size: 64px;

  text-decoration: underline;

  margin: 0;
}
.title > a {
   color: white;
}
.subtitle {
  margin: 0;
}

.introduction {
  display: flex;
  flex-direction: row;
  gap: 2em;
  font-family: "Fira Code";
}


.spacerBig {
  margin-top: 20vh;
}
.spacerSmall {
  margin-top: 25vh;
}

@media screen and (max-width: 800px) {

  .card {
    margin: 0 auto 0 auto;
    max-width: 90vw;
  }
  
  .introduction {
    flex-direction: column;
  }

  .title {
    font-size: 32px;
    text-align: center;
  }

  .subtitle {
    margin-top: 4px;
    font-size: 16px;
    text-align: center;
  }
  .iconColumn {
    display: flex;
  }

  .icon {
    margin: auto;
    width: 100%;
  }

  .spacerSmall {
    margin-top: 15vh;
  }
  .spacerBig {
    margin-top: 10vh;
  }
}


.description {
  font-style: italic;
}

.textColumn {
  flex: 1;
}

.iconColumn {
}

.icon {
  width: 200px;
}

.footer {
  color: white;
  width: 100%;
  text-align: center;

  font-family: "Fira Code";

  display: flex;
  flex-direction: column;
  
  position: relative;
}

.footerImage {
  max-width: 1152px;
  width: 100%;
  margin: 120px auto -42px;

  pointer-events: none;
}

.social > h2 {
  margin: 0;
  text-align: center;
}

.socialList {
  list-style: none;
  margin: 0 auto;
  padding: 0;

  display: flex;
  flex-direction: row;
  justify-content: center;
  
  gap: 32px;
}

.socialList > li {
  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;
}

.socialEntryWIP {
  border: 1px solid white;
  border-radius: 8px;

  width: 64px;
  height: 64px;
}

.socialImage {
  width: 48px;
  height: 48px;
}